export const INLINE_LUMINA_STATUS_PREFIX = 'inline-lumina-';

export const isInlineLuminaStatus = (localId?: string): boolean => {
	return localId != null && localId.startsWith(INLINE_LUMINA_STATUS_PREFIX);
};
